package pwgs.ui.scenes.projectlist

import visage.core.AComponent
import visage.core.Components
import visage.core.AScene
import visage.ds.components.*
import visage.ds.components.page.*
import visage.ds.utils.ETextAlign
import visage.ds.utils.RenderMode

class MProjectListScene(props: ProjectListSceneProps) : AScene<ProjectListSceneProps, ProjectListSceneModel, ProjectListSceneState, ProjectListControllerFe>(props) {

    override fun createController() : ProjectListControllerFe {
        return ProjectListControllerFe(props, this)
    }

    override fun initState() : ProjectListSceneState {
        return ProjectListSceneState()
    }

    override fun Components.render(children: List<AComponent<*>>) {
        val m = this@MProjectListScene.model

        Application {

            menu {
                footer {
                    menuItem("Logout", "logout", "/app/logout.vsg")
                }
            }

            Page {
                isLoading = m.isLoading
                head("Projects")
                body {
                    Card {
                        header("Projects") {
                            ResponsiveButtonWithIcon(
                                "add",
                                "Create new Project",
                                EButtonColor.Success,
                                this@MProjectListScene.controller::onCreateProjectButtonClicked
                            )
                        }
                        body {
                            if (m.projects.size < 1) {
                                Text(
                                    "It seems that you don't have any projects yet. Create one with the button above!",
                                    ETextStyles.Normal,
                                    true
                                ) {
                                    textAlign = ETextAlign.CENTER
                                }
                            } else {
                                Table {
                                    columns {
                                        fixedColumn("Name")
                                    }
                                    body {
                                        m.projects.forEach { proj ->
                                            row {
                                                onClick =
                                                    { this@MProjectListScene.controller.onProjectClicked(proj.id) }
                                                cell(proj.name)
                                            }
                                        }
                                    }
                                }
                            }

                            if (m.createProjectDialogModel != null) {
                                Modal("Create new project") {
                                    error = m.createProjectDialogModel!!.error
                                    infoText = "Fill this form to create a new Gamend project"
                                    isLoading = m.createProjectDialogModel!!.isLoading

                                    TextField("Project name", m.createProjectDialogModel!!.name) {
                                    }

                                    footer {
                                        Button(
                                            "Cancel",
                                            EButtonColor.Secondary,
                                            EButtonVariant.Link,
                                            this@MProjectListScene.controller::onCancelCreateNewProjectclicked
                                        )
                                        Button(
                                            "Create",
                                            EButtonColor.Primary,
                                            EButtonVariant.Filled,
                                            this@MProjectListScene.controller::createProject
                                        )
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

class ProjectListSceneState {

}

fun Components.ProjectListScene(props: ProjectListSceneProps) = this.registerComponent(MProjectListScene(props), {})
